<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OLsh89/tc-custom/9781938120503.jpg?1721429486626" alt="This image is the cover for the book Good Enough to Dream"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Good Enough to Dream
      </h1>
      <p class="bookDescription body article font2">
        <b>The true story of a year in the life of the Utica Blue Sox, a minor league baseball team in upstate New York, by the acclaimed author of <i>The Boys of Summer</i>. </b><br/>  <br/> Roger Kahn’s <i>The Boys of Summer</i> immortalized the 1950s Brooklyn Dodgers. <i>Good Enough to Dream</i> does the same for players whose moment in the sun has not yet arrived.<br/>  <br/> Here, Kahn tells the story of his year as owner of the Class A, very minor league Utica Blue Sox. Most of the Blue Sox never made it to the majors, but they all shared the dream that links the small child in the sandlot with the superstar who has just smacked one out of the stadium. This is a look at the heart of America’s pastime, a game still sweet enough to lure grown men to leagues where first-class transportation was an old school bus and the infield was likely to be the consistency of thick soup. It is a funny and poignant story of one season, and one special team, that will make us hesitate before we ever call anything “bush league” again.<br/>  <br/><b>Praise for Roger Kahn</b><br/> “As a kid, I loved sports first and writing second, and loved everything Roger Kahn wrote. As an adult, I love writing first and sports second, and love Roger Kahn even more.” —David Maraniss, Pulitzer Prize winner<br/>  <br/> “He can epitomize a player with a single swing of the pen.” —<i>Time</i><br/>  <br/> “Roger Kahn is the best baseball writer in the business.” —Stephen Jay Gould, <i>The New York Review of Books</i> 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Roger Kahn
      </h2>
      
      <p class="authorDescription body article">Roger Kahn, a prize-winning author, grew up in Brooklyn, where he believed everybody on the boys&#39; varsity baseball team at his prep school wanted to play for the Dodgers. None did. He wrote nineteen books. Like most natives of Brooklyn, he was distressed that the Dodgers left. &quot;In a perfect world,&quot; he said, &quot;the Dodgers would have stayed in Brooklyn and Los Angeles would have gotten the Mets.&quot;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6597cbfe